{
  "main": {
    "pt-BR": {
      "identity": {
        "version": {
          "_number": "$Revision: 14842 $",
          "_cldrVersion": "35.1"
        },
        "language": "pt"
      },
      "numbers": {
        "defaultNumberingSystem": "latn",
        "otherNumberingSystems": {
          "native": "latn"
        },
        "minimumGroupingDigits": "1",
        "symbols-numberSystem-latn": {
          "decimal": ",",
          "group": ".",
          "list": ";",
          "percentSign": "%",
          "plusSign": "+",
          "minusSign": "-",
          "exponential": "E",
          "superscriptingExponent": "×",
          "perMille": "‰",
          "infinity": "∞",
          "nan": "NaN",
          "timeSeparator": ":"
        },
        "decimalFormats-numberSystem-latn": {
          "standard": "#,##0.###",
          "long": {
            "decimalFormat": {
              "1000-count-one": "0 mil",
              "1000-count-other": "0 mil",
              "10000-count-one": "00 mil",
              "10000-count-other": "00 mil",
              "100000-count-one": "000 mil",
              "100000-count-other": "000 mil",
              "1000000-count-one": "0 milhão",
              "1000000-count-other": "0 milhões",
              "10000000-count-one": "00 milhão",
              "10000000-count-other": "00 milhões",
              "100000000-count-one": "000 milhão",
              "100000000-count-other": "000 milhões",
              "1000000000-count-one": "0 bilhão",
              "1000000000-count-other": "0 bilhões",
              "10000000000-count-one": "00 bilhão",
              "10000000000-count-other": "00 bilhões",
              "100000000000-count-one": "000 bilhão",
              "100000000000-count-other": "000 bilhões",
              "1000000000000-count-one": "0 trilhão",
              "1000000000000-count-other": "0 trilhões",
              "10000000000000-count-one": "00 trilhão",
              "10000000000000-count-other": "00 trilhões",
              "100000000000000-count-one": "000 trilhão",
              "100000000000000-count-other": "000 trilhões"
            }
          },
          "short": {
            "decimalFormat": {
              "1000-count-one": "0 mil",
              "1000-count-other": "0 mil",
              "10000-count-one": "00 mil",
              "10000-count-other": "00 mil",
              "100000-count-one": "000 mil",
              "100000-count-other": "000 mil",
              "1000000-count-one": "0 mi",
              "1000000-count-other": "0 mi",
              "10000000-count-one": "00 mi",
              "10000000-count-other": "00 mi",
              "100000000-count-one": "000 mi",
              "100000000-count-other": "000 mi",
              "1000000000-count-one": "0 bi",
              "1000000000-count-other": "0 bi",
              "10000000000-count-one": "00 bi",
              "10000000000-count-other": "00 bi",
              "100000000000-count-one": "000 bi",
              "100000000000-count-other": "000 bi",
              "1000000000000-count-one": "0 tri",
              "1000000000000-count-other": "0 tri",
              "10000000000000-count-one": "00 tri",
              "10000000000000-count-other": "00 tri",
              "100000000000000-count-one": "000 tri",
              "100000000000000-count-other": "000 tri"
            }
          }
        },
        "scientificFormats-numberSystem-latn": {
          "standard": "#E0"
        },
        "percentFormats-numberSystem-latn": {
          "standard": "#,##0%"
        },
        "currencyFormats-numberSystem-latn": {
          "currencySpacing": {
            "beforeCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            },
            "afterCurrency": {
              "currencyMatch": "[:^S:]",
              "surroundingMatch": "[:digit:]",
              "insertBetween": " "
            }
          },
          "standard": "¤ #,##0.00",
          "accounting": "¤ #,##0.00",
          "short": {
            "standard": {
              "1000-count-one": "¤ 0 mil",
              "1000-count-other": "¤ 0 mil",
              "10000-count-one": "¤ 00 mil",
              "10000-count-other": "¤ 00 mil",
              "100000-count-one": "¤ 000 mil",
              "100000-count-other": "¤ 000 mil",
              "1000000-count-one": "¤ 0 mi",
              "1000000-count-other": "¤ 0 mi",
              "10000000-count-one": "¤ 00 mi",
              "10000000-count-other": "¤ 00 mi",
              "100000000-count-one": "¤ 000 mi",
              "100000000-count-other": "¤ 000 mi",
              "1000000000-count-one": "¤ 0 bi",
              "1000000000-count-other": "¤ 0 bi",
              "10000000000-count-one": "¤ 00 bi",
              "10000000000-count-other": "¤ 00 bi",
              "100000000000-count-one": "¤ 000 bi",
              "100000000000-count-other": "¤ 000 bi",
              "1000000000000-count-one": "¤ 0 tri",
              "1000000000000-count-other": "¤ 0 tri",
              "10000000000000-count-one": "¤ 00 tri",
              "10000000000000-count-other": "¤ 00 tri",
              "100000000000000-count-one": "¤ 000 tri",
              "100000000000000-count-other": "¤ 000 tri"
            }
          },
          "unitPattern-count-one": "{0} {1}",
          "unitPattern-count-other": "{0} {1}"
        },
        "miscPatterns-numberSystem-latn": {
          "approximately": "~{0}",
          "atLeast": "+{0}",
          "atMost": "≤{0}",
          "range": "{0}–{1}"
        },
        "minimalPairs": {
          "pluralMinimalPairs-count-one": "{0} dia",
          "pluralMinimalPairs-count-other": "{0} dias",
          "other": "Pegue a {0}ª à direita."
        }
      }
    }
  }
}
